export const UPDATE_REISSUE_REQUEST = 'UPDATE_REISSUE_REQUEST'
export const UPDATE_REISSUE_SUCCESS = 'UPDATE_REISSUE_SUCCESS'
export const UPDATE_REISSUE_FAILED = 'UPDATE_REISSUE_FAILED'

export const CLEAR_REISSUE = 'CLEAR_REISSUE'
